import '../scss/styles.scss'

import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
import fslightbox from "fslightbox";
import Splide from '@splidejs/splide';
import "@splidejs/splide/dist/css/splide.min.css"
import Countable  from 'countable'

import * as experts from './experts.js';
import * as recherche from './recherche.js';
import * as quizz from './quizz.js';
import * as selects from './selects.js';


let sliderMedias = null

document.addEventListener("DOMContentLoaded", function (event) {
  init()

 


});


const init = function () {

  initClick()

  initScroll()

  initReveal()


  // Gestion couleurs de section Firefox
  if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){

    console.log('firefox')
    if (document.querySelector('.section-contenu')) {

      const sections = document.querySelectorAll('.section-contenu')
      sections.forEach((element,index)  => {
        console.log
          if(index % 2!=0){ // odd
            element.style.backgroundColor = '#f4f6f8'
          }
          else { // even
            element.style.backgroundColor = 'transparent'
          }
      });
    }

    if (document.querySelector('.paragraph--type--section-layout')) {
      const sectionsNew = document.querySelectorAll('.paragraph--type--section-layout')
        sectionsNew.forEach((element,index)  => {
          if(index % 2==0){ // even
            element.style.backgroundColor = '#f4f6f8'
          }
          else { // odd
            element.style.backgroundColor = 'transparent'
          }
      });
    }
  }




  if (document.querySelector('.zone-section-contenus')) fondFinContenus()

//   var image = document.querySelectorAll('.parallax-window');
// new simpleParallax(image, {

// });

  // Init Selects
  if (document.querySelector('.custom-select')) {
    selects.init()
  }

  // Init Quizz
  if (document.querySelector('.quizz')) {
    document.querySelectorAll('.quizz').forEach(element => {
      quizz.init(element)
    });
  }

  // Init recherche
  const search = recherche.init()

  // Init des selecteurs
  if (document.querySelector('.select__open')) initSelect()
  if (document.querySelector('.select__conteneur--simple')) initSelectSimple()

  // Init titre page
  if (titre) {
    document.querySelector('.navbar-menu__titre').innerHTML = titre
  }

  // Init filtres experts
  const expertsNav = experts.init()

  // Slides
  if (document.querySelector('.slide-medias')) {
  
    var slidersMedias = document.querySelectorAll('.slide-medias')
  
    slidersMedias.forEach(element => {
  
      new Splide(element, {
        arrows: true,
      pagination: false,
      type: 'slide',
      keyboard: true,
      perMove: 1,
      autoplay: false,
      perPage: 3,
      breakpoints: {
        640: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
      }
      }).mount();
    });
  }

  // Slides dans les lightboxs
  if (typeof fsLightbox !== 'undefined') {
    fsLightbox.props.onOpen = function (instance) {
    
      if (document.querySelector('.splide-infographie')) {
        var slidersInfos = document.querySelectorAll('.splide-infographie')
     
        slidersInfos.forEach(element => {
  
           // largeur de slide
        var img = element.querySelector('.splide__list li img')
        element.querySelector('.splide__track').style.width = img.width+'px'
    
          var splideInfo = new Splide(element, {
            arrows: true,
            pagination: true,
            type: 'slide',
            keyboard: true,
            perMove: 1,
            autoplay: false,
            perPage: 1,
          }).mount();

          // element.querySelector('.splide__track').style.width = img.width+'px'
  
          fsLightbox.props.onClose = function (instance) {
            splideInfo.destroy(true)
          }
        });
  
      }
    }
  }
  
 


  if (document.querySelector('.slide-expressions')) {

    var splidesExp = document.querySelectorAll('.slide-expressions')
    splidesExp.forEach(element => {
      new Splide(element, {
        arrows: true,
        pagination: false,
        type: 'slide',
        keyboard: true,
        perMove: 1,
        autoplay: false,
        perPage: 2,
        breakpoints: {
          1024: {
            perPage: 1,
          },
          640: {
            destroy: true,
          },
        }
      }).mount();
    });

  }

      if (document.querySelector('.splide--publication')) {
    var splidesPub = document.querySelectorAll('.splide--publication')
    splidesPub.forEach(element => {
      new Splide(element, {
        arrows: true,
        pagination: true,
        type: 'slide',
        keyboard: true,
        perMove: 1,
        autoplay: false,
      }).mount();
    });

  }


  // Accordeons

  if (document.querySelector('.accordions')) {

    const accord = document.querySelectorAll('.accordions')
    accord.forEach(element => {
      new Accordion('#'+element.id);
    });
   
  }

  // Durée de lecture
  if (document.querySelector('article.contenu-expressions') && document.querySelector('#readingTime')) {
    const wpm = 220;
    const area = document.querySelector('article.contenu-expressions .section-contenu')
    const callback = counter =>  document.getElementById("readingTime").innerText = Math.ceil(counter.words / wpm)+' minutes' ;  
    const log = counter =>  console.log('Nbr mots',counter.words) ;  


    Countable.on(area, log)
    Countable.on(area, callback)
  }

}

const overlayMenu = document.querySelector('.overlay-menu')
const groupeMenu = document.querySelector('.groupe-mega-menu')
const nav = document.querySelectorAll('.navbar-item')
const brand = document.querySelector('.navbar-brand')
const navBar = document.querySelector('#main-navbar')

// Couleur de la zone en bas d'une publication (auteurs / imprimer /partager )
const fondFinContenus = function () {
  const zone = document.querySelector('.zone-section-contenus')
  let item = null
  if (document.querySelector('.lpb-formatter')) {
    item = zone.querySelector('.lpb-formatter').lastElementChild
  }
  else item = zone.lastElementChild

  console.log(item)
  const style = getComputedStyle(item)
  console.log(style.backgroundColor)
  document.querySelector('.section-contenu-footer').style.backgroundColor = style.backgroundColor
}

const initClick = function () {

  // Gestion du menu desktop


  // Menu sommaire d'une publication
  const lienSections = document.querySelectorAll('.lien-section')
  lienSections.forEach(lien => {
    lien.addEventListener('click', function (e) {
      fermeTout()
      console.log('clic')
    }) 
  });


  // Femre le mega menu au roll overlay
  overlayMenu.addEventListener('mouseenter', function (e) {
    fermeMegaMenu()
  })
  brand.addEventListener('mouseenter', function (e) {
    fermeMegaMenu()
  })

  document.querySelector('.navbar-menu').addEventListener('mousemove', function (e) {
    e.stopPropagation();
    if (e.target.classList.contains('navbar-menu') || e.target.classList.contains('navbar-start')) {
      fermeMegaMenu()
    }
  })


  overlayMenu.addEventListener('click', function (e) {
    fermeTout()
  })

  //   document.querySelector('#main-navbar').addEventListener('mouseenter', function(e) {
  //     fermeMegaMenu()
  //  })

  nav.forEach(item => {

    item.addEventListener("mouseenter", function (e) {

      if (!item.classList.contains('is-active')) {
        var idMenu = e.target.dataset.megaMenu

        // Désactiver les autres menus
        menuLateral.classList.remove('is-active')
        document.querySelectorAll('.navbar-item').forEach(itemNav => {
          if (itemNav.dataset.megaMenu != idMenu) itemNav.classList.remove('is-active')
        })
        document.querySelectorAll('.mega-menu').forEach(itemMenu => {
          if (itemMenu.dataset.megaMenu != idMenu) itemMenu.classList.remove('is-active')
        })

        // Activer les menus
        if (document.querySelector("[data-mega-menu='" + idMenu + "']")) {
          document.querySelectorAll("[data-mega-menu='" + idMenu + "']").forEach(itemNav => {
            itemNav.classList.toggle('is-active')
          })

        }

        // Ouvrir ou fermer
        if (document.querySelector("[data-mega-menu='" + idMenu + "']").classList.contains('is-active')) {
          overlayMenu.classList.add('is-active')
          groupeMenu.classList.add('is-active')
        } else {
          overlayMenu.classList.remove('is-active')
          groupeMenu.classList.remove('is-active')
        }
      }


    })

  });



  //  Menu Thèmmes docké
  const btThemes = document.querySelector('#bt-themes')
  btThemes.addEventListener('click', function (e) {
    e.preventDefault()
    fermeMegaMenu()
    
    navBar.classList.add('is-docked-themes')
    // menuLateral.classList.add('is-active')
    // overlayMenu.classList.add('is-active-lateral')
    // overlayMenu.classList.add('is-active')

  })
  document.querySelector('.navbar-theme-close').addEventListener('click', function (e) {
    navBar.classList.remove('is-docked-themes')
  })

  // Menu mobile 
  const burgerMobile = document.querySelector('.navbar-burger-mobile')
  const menuLateral = document.querySelector('.menu-lateral')
  burgerMobile.addEventListener('click', function (e) {
    e.preventDefault()
    menuLateral.classList.toggle('is-active')
    burgerMobile.classList.toggle('is-active-menulateral')
    document.querySelector('body').classList.toggle('noscroll')
  }) 

  


  // Menu Latéral desktop
  const burger = document.querySelector('#bt-menu')
  burger.addEventListener('click', function (e) {
    e.preventDefault()
    fermeMegaMenu()
    menuLateral.classList.add('is-active')
    navBar.classList.add('is-active-menulateral')
    overlayMenu.classList.add('is-active-lateral')
    overlayMenu.classList.add('is-active')

  }) 
  // Fermer menu lateral Desktop
  const fermeMenu = document.querySelector('#close-menu-lateral')
  fermeMenu.addEventListener('click', function (e) {
    e.preventDefault()
    fermeMegaMenu()
    menuLateral.classList.remove('is-active')
    navBar.classList.remove('is-active-menulateral')
    overlayMenu.classList.remove('is-active-lateral')
    overlayMenu.classList.remove('is-active')

  })

  // Imprimer
  if (document.querySelector('.bt-imprimer')) {

    const print = document.querySelectorAll('.bt-imprimer')
    print.forEach(element => {
      element.addEventListener('click', function (e) {
        window.print()
      })
    });

  }

  // Language switch 
  if (document.querySelector('.zone-langues')) {
    const langues = document.querySelector('.zone-langues')
    langues.addEventListener('click', function (e) {
      if( e.target.classList.contains('is-active')   ) {
        langues.querySelector('ul.links').classList.toggle('is-active')
      };
    })
  }


  // Menu des publications

  if (document.querySelector('.publication-navigation__menu')) {
    const menu = document.querySelectorAll('.publication-navigation__label')
    menu.forEach(element => {
      element.addEventListener('click', function (e) {
        if (this.parentNode.classList.contains('is-active')) {
          this.parentNode.classList.remove('is-active')
          overlayMenu.classList.remove('is-active')
        } else {
          menu.forEach(element2 => {
            element2.parentNode.classList.remove('is-active')
            this.parentNode.classList.add('is-active')
            overlayMenu.classList.add('is-active')
          })
        }
      })
    });
  }


  // Navigation soutins
  if (document.querySelector('.navigation-lettres')) {
    const navLettre = document.querySelectorAll('.navigation-lettres li')
    const navGRoupes = document.querySelectorAll('.soutiens-groupe')
    navLettre.forEach(element => {
      element.addEventListener('mouseenter', function (e) {
        navGRoupes.forEach(element2 => {
          element2.classList.remove('is-active')
        })
        navLettre.forEach(element2 => {
          element2.classList.remove('is-active')
        })

        var lettre = e.target.dataset.lettre
        document.querySelector('#lettre_'+lettre).classList.add('is-active')
        element.classList.add('is-active')
      })
      
    });
  }

  if (document.querySelector('.tabs-group')) {

    // Tous les groupes d'onglets
    const tabsGroup = document.querySelectorAll('.tabs-group')
    tabsGroup.forEach(group => {

      // Onglets du groupe
      const tabs = group.querySelectorAll('.tabs-container .tabs ul li')
      const tabsContent = group.querySelectorAll('.tab-content ')
      tabs.forEach(element => {

        element.addEventListener('click', function (e) {
          var tab = e.target
          tabs.forEach(element2 => {
            element2.classList.remove('active')
          })
          tab.parentNode.classList.toggle('expanded')
          tab.classList.add('active')

          //$('li').removeClass('active');
          //$('ul').toggleClass('expanded');
          //$(this).addClass('active');

          var tabId = tab.dataset.tab
          tabsContent.forEach(element2 => {
            if (element2.dataset.tab != tabId) element2.classList.remove('current')
            else element2.classList.add('current')
          })

          // var tab_id = $( e.target).attr('data-tab');
          // $('.tab-content').removeClass('current');
          // $(this).addClass('current');
          // $('#'+tab_id).addClass('current');
        })
      });
    })
  }
}


const initSelect = function () {

  const selects = document.querySelectorAll('.select__open')
  selects.forEach(element => {
    element.addEventListener('click', function (e) {
      e.preventDefault()
      fermeMegaMenu()
      e.target.parentNode.classList.toggle('is-active')
    })
  });
}

const  initSelectSimple = function () {
  
  const selects = document.querySelectorAll('.select__conteneur--simple')
  selects.forEach(element => {
    
    // Menu
    element.addEventListener('click', function (e) {
      e.preventDefault()
      fermeMegaMenu()
      if(e.target.classList.contains('select__conteneur--simple')) e.target.classList.toggle('is-active')
    })
    
    // Choix
    const choix = element.querySelectorAll('.choix')
    choix.forEach(choix1 => {
      choix1.addEventListener('click', function (e) {
        e.preventDefault()
       
        choix.forEach(choix2 => {
          choix2.classList.remove('is-active')
        }) 
        e.target.classList.add('is-active')
        e.target.parentNode.parentNode.classList.remove('is-active')  
      })
    })


  });



}


const initScroll = function () {
  let lastKnownScrollPosition = 0
  let direction = null
  let ticking = false
  let posDock = null

  if (document.querySelector('#limit-dock')) posDock = document.querySelector('#limit-dock').getBoundingClientRect()


  function testDock() {
    if ((direction == 'down') && (posDock.top <= lastKnownScrollPosition)) {
      fermeMegaMenu()
      navBar.classList.add('is-docked')
    } 
    else if ((direction == 'up') && (posDock.top >= lastKnownScrollPosition)) {
      navBar.classList.remove('is-docked')
      navBar.classList.remove('is-docked-themes')
      
    }
  }

  document.addEventListener('scroll', (e) => {

    if (lastKnownScrollPosition <= window.scrollY) direction = 'down'
    else direction = 'up'

    lastKnownScrollPosition = window.scrollY
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (posDock) testDock()
        ticking = false
      });

      ticking = true
    }
  });
}




const threshold = .1
const options = {
  root: null,
  rootMargin: '0px',
  threshold
}

const initReveal = function () {
  const handleIntersect = function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio > threshold) {
         entry.target.classList.remove('reveal')
         observer.unobserve(entry.target)


      }
    })
  }
  document.documentElement.classList.add('reveal-loaded')

    const observer = new IntersectionObserver(handleIntersect, options)
    const targets = document.querySelectorAll('.reveal')
    targets.forEach(function (target) {
      observer.observe(target)
    })

  const observeDock = new IntersectionObserver(handleIntersect, options)
  if (document.querySelector('#limit-dock')) {
    const limitDocked = document.querySelector('#limit-dock')
    observeDock.observe(limitDocked)
  }
}





const fermeTout = function () {
  document.querySelector('.overlay-menu').classList.remove('is-active')
  document.querySelector('.overlay-menu').classList.remove('is-active-lateral')
  document.querySelector('.publication-navigation__menu.is-active').classList.remove('is-active')
}


const fermeMegaMenu = function () {

  // Uniquement pour les mega menu
  if (!document.querySelector('.menu-lateral').classList.contains('is-active') && !document.querySelector('.publication-navigation__menu.is-active')) {
    document.querySelector('.overlay-menu').classList.remove('is-active')
    document.querySelector('.overlay-menu').classList.remove('is-active-lateral')
  }

  document.querySelector('.groupe-mega-menu').classList.remove('is-active')
  document.querySelectorAll('.navbar-item').forEach(itemNav => {
    itemNav.classList.remove('is-active')
  })
  document.querySelectorAll('.mega-menu').forEach(itemNav => {
    itemNav.classList.remove('is-active')
  })
}


///

var _overlay = document.querySelector('.menu-lateral');
var _clientY = null; // remember Y position on touch start

_overlay.addEventListener('touchstart', function (event) {
  if (event.targetTouches.length === 1) {
    // detect single touch
    _clientY = event.targetTouches[0].clientY;
  }
}, {passive: true});

_overlay.addEventListener('touchmove', function (event) {
  if (event.targetTouches.length === 1) {
    // detect single touch
    disableRubberBand(event);
  }
}, {passive: true});

function disableRubberBand(event) {
  var clientY = event.targetTouches[0].clientY - _clientY;

  if (_overlay.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll
    event.preventDefault();
  }

  if (isOverlayTotallyScrolled() && clientY < 0) {
    //element is at the top of its scroll
    event.preventDefault();
  }
}

function isOverlayTotallyScrolled() {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
  return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
}